export function bindDatabaseCrudMethods<
  TRaw extends {
    insert: { bind(context: TRaw): TRaw["insert"] };
    select: { bind(context: TRaw): TRaw["select"] };
    update: { bind(context: TRaw): TRaw["update"] };
  },
>(raw: TRaw) {
  return {
    insert: raw.insert.bind(raw),
    select: raw.select.bind(raw),
    update: raw.update.bind(raw),
  };
}
